<template>
    <div class="relaying  mainBody">
        <div class="input_area">
            <div class="input_box">
                <div class="box_top">
                    <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.lable}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item1.selectOrinput" class="input_label" for="input">{{groupList.item1.lable}}</label>
                        <el-input v-if="!groupList.item1.selectOrinput" id="input" class="inputInner" v-model="groupList.item1.value" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="timePicker">{{groupList.item2.lable}}</label>
                        <el-date-picker id="timePicker" class="inputInner" v-model="groupList.item2.value" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </div>
                    <div class="input_group" v-if="groupList.item3.isShow">
                        <label v-if="groupList.item3.selectOrinput" class="input_label" for="select">{{groupList.item3.lable}}</label>
                        <el-select v-if="groupList.item3.selectOrinput" id="select" class="inputInner" v-model="groupList.item3.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item3.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item3.selectOrinput" class="input_label" for="input">{{groupList.item3.lable}}</label>
                        <el-input v-if="!groupList.item3.selectOrinput" id="input" class="inputInner" v-model="groupList.item3.value" placeholder="请输入内容"></el-input>
                    </div>
                    <div class="input_group" v-if="groupList.item4.isShow">
                        <label v-if="groupList.item4.selectOrinput" class="input_label" for="select">{{groupList.item4.lable}}</label>
                        <el-select v-if="groupList.item4.selectOrinput" id="select" class="inputInner" v-model="groupList.item4.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item4.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item4.selectOrinput" class="input_label" for="input">{{groupList.item4.lable}}</label>
                        <el-input v-if="!groupList.item4.selectOrinput" id="input" class="inputInner" v-model="groupList.item4.value" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="box_bottom" v-if="boxBottom.isBoxBottom">
                        <label class="input_label" for="beizhu">{{boxBottom.label}}</label>
                        <el-input  id="beizhu" v-model="boxBottom.input" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="add_box">
                <button @click='submit' class="formButton add_btn" >添加</button>
            </div>
        </div>
        <div class="table_area">
                <el-table
                :stripe='true'
                        :data="tableData"
                        height="100%"
                        style="width: 100%;"
                        >
                        <el-table-column
                            prop="geotextileName"
                            label="重铺排体"
                            align='center'
                            width='300'
                            >
                        </el-table-column>
                        <el-table-column
                            prop="engineerregion_id"
                            label="工区"
                            align='center'>
                            
                        </el-table-column>
                        <el-table-column
                            prop="boat_id"
                            label="施工船舶"
                            align='center'>
                        </el-table-column>
                        <el-table-column
                            prop="resetTime"
                            label="重铺时间"
                            align='center'
                            width='300px'>
                            <template slot-scope="scope">
                            <el-date-picker id="timePicker" class="inputInner" v-model="tableData[scope.$index].resetTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="option"
                            label="操作"
                            align='center'>
                            <!-- <button @click='openAmend' class="tablebtn_inner btnView">修改</button> -->
                            <template slot-scope="scope">
                                <button
                                class="tablebtn_inner btnView"
                                @click="openAmend(scope.$index,scope.row)">修改</button>
                                <button
                                class="tablebtn_inner btnView"
                                @click="openDelete(scope.$index,scope.row)">删除</button>
                            </template>
                        </el-table-column>
                </el-table>

        </div>
        
    </div>
</template>

<script>
// import css from '@/css/form.css'
import API from '@/api/material.js'
import moment from 'moment'
export default {
    name:'relaying',
    data(){
        return{
            value:'',
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择重铺排体',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'重铺时间',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item3:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    lable:'重铺原因',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item4:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'重铺验收情况',
                    selectOptions:[
                        {
                            value:'已验收',
                            label:'已验收'
                        },
                        {
                            value:'未验收',
                            label:'未验收'
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                length:4
            },
            boxBottom:{
                isBoxBottom:true,
                 input:'',
                 label:'备注'
                
            },
            tableData: [],
            AllClass:this.$store.state.AllClass,
            
        }
    },
    methods:{
        timestamp(date){
            return moment(date).format("x");
        },
        amend(index,row){
            // &id=1&geotextileName=太古第er排&resetTime=2023-12-22 10:11:11&reason=不规范2&check=未完成&note=
            let list = this.tableData
            let param = {
                action:'update',
                resetGeotextileId:list[index].resetGeotextileId,
                resetTime:list[index].resetTime,
                reason:list[index].reason,
                check:list[index].check,
                // note:this.boxBottom.input,
            }
            return new Promise((resolve,reject)=>{
                API.updateRelayingList(param).then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            }) 
        },
        delete(index,row){
            // &id=1&geotextileName=太古第er排&resetTime=2023-12-22 10:11:11&reason=不规范2&check=未完成&note=
            let list = this.tableData
            let param = {
                action:'delete',
                resetGeotextileId:list[index].resetGeotextileId,
            }
            return new Promise((resolve,reject)=>{
                API.deleteRelayingList(param).then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            }) 
        },
        openDelete(index,row) {
            this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.delete(index,row).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '删除成功',
                        type: 'success'
                        });
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '删除失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }).catch(err=>{
                    console.log('1',err);
                })
            }).catch(err=>{
                console.log('2',err);
            })
        },
        addMethod(){
            // action=add&geotextileName=太古第一排&resetTime=2023-12-22 10:11:11&reason=不规范&check=未完成&note=
            let list = this.groupList
            let note = this.boxBottom
                let tmpValue ={
                    action:'add',
                    geotextile_id:list.item1.value,
                    resetTime:list.item2.value||'',
                    reason:list.item3.value||'',
                    check:list.item4.value||'',
                    note:note.input||'',
                };
             return new Promise((resolve,reject)=>{
                    API.getMattressList(tmpValue).then(res=>{
                        resolve(res)
                    }).then(()=>{
                        this.synchrodata();
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                })  
        },
        open() {
            this.$confirm('是否确认添加, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.addMethod().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '添加成功',
                        type: 'success'
                        });
                    }else{
                        this.$message({
                        message: '添加失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
            })
            .catch(() => {
            this.$message({
                type: 'info',
                message: '已取消添加'
            });          
            });
        },
        openAmend(index,row) {
            this.$confirm('是否确认修改, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.amend(index,row).then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '修改成功',
                        type: 'success'
                        });
                    }else{
                        this.$message({
                        message: '修改失败，请稍后再试',
                        type: 'error'
                        });
                    }
                }).catch(err=>{
                    console.log('1',err);
                })
            }).catch(err=>{
                console.log('2',err);
            })
        },
       
        synchrodata(){  
                    this.getGroupList();
                    this.getTableList();
        },
        submit(){
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.open()
              
            } 
        },
        verifyMainLabel() {
            let result = true;
           for(var i = 1;i <= this.groupList.length>0?this.groupList.length:0;i++){

                if(`${this.groupList[`item${i}`].value}` == '' ||this.groupList[`item${i}`].value == null){
                    result = false;
                }
            }
            return result
        },
        formattingDate(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
            },
        formatMattressList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].geotextile_id,
                    label:list[i].geotextile_name,
                })
            }
            return tmpList

        },
        getGroupList(){
            API.getMattressList({action:'view'}).then((res)=>{
                this.groupList.item1.selectOptions = this.formatMattressList(res.message.obj);
            }).catch(err=>{
                console.log(err);
            });

        },
        formatTableList(lists){
            let tmpList = [];
            let list = lists?lists:[];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    resetGeotextileId:list[i].resetGeotextileId,
                    geotextileName:list[i].geotextileName,
                    geotextile_id:list[i].geotextile_id,
                    engineerregion_id:list[i].engineerregion_id,
                    boat_id:list[i].boat_id,
                    resetTime:this.formattingDate(list[i].resetTime),
                    unit:'米',
                    option:'修改'
                })
            }
            return tmpList
        },
        getTableList(){
            API.getRelayingList(this.$store.state.API_params).then((res)=>{
                this.tableData = this.formatTableList(res.message.obj||{});
            }).catch(err=>{
                console.log(err);
            });
        }
    },
    mounted(){
        this.synchrodata();
    }
}
</script>

<style scoped>
.relaying{
    height: 100%;
    width: 90%;
    margin: 0 auto;
}
.innerInput{
    border: none;
    border-radius: var(--border--radius);
    background-color: var(--subject--input);
    transition: var(--subject--transition);
    color:var(--subject--text) ;
    width: 50%;
    cursor: pointer;
}

</style>>


